import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { translate } from 'translations/translator';
import { Typography, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';

const getTranslation = key => translate('lessonPlanner', key);

type Props = {
  type: 'duration' | 'noActivities' | 'editWarning';
  duration?: number | undefined;
  style?: any;
};

export const StepOneAssignmentAlerts: React.FC<Props> = ({ type, duration, ...props }) => {
  const classes = useStyles()();

  switch (type) {
    case 'noActivities':
      return (
        <Alert className={classes.alertClass} {...props} severity="warning">
          {getTranslation('warningNoActivities')}
        </Alert>
      );
    case 'duration':
      return (
        <Alert
          icon={<FontAwesomeIcon icon={faClock} size="sm" />}
          className={classes.alertClass}
          {...props}
          severity="info"
        >
          {getTranslation('durationNotification')}: {duration} {getTranslation('minutes')}
        </Alert>
      );
    case 'editWarning':
      return (
        <Alert className={classes.alertClass} {...props} severity="warning">
          <Typography>
            {getTranslation('cannotEditWarning1')}{' '}
            <span style={{ fontWeight: 300 }}>{getTranslation('cannotEditWarning2')}</span>
          </Typography>
        </Alert>
      );
    default:
      return <div />;
  }
};

const useStyles = () =>
  makeStyles(() => ({
    alertClass: {
      width: '100%',
      margin: '27px 32px 0px 32px'
    }
  }));
